import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'

const PROGRESS_BAR_DOTS = '[data-free-shipping-progress-bar-dots]'
const MESSAGE_NODE_SELECTOR = '[data-free-shipping-bar-message]'
const DIFFERENCE_ATTRIBUTE = 'data-free-shipping-difference'
const DIFFERENCE_PERCENT_ATTRIBUTE = 'data-free-shipping-difference-percent'
const PROGRESS_MESSAGE_ATTRIBUTE = 'data-progress-message'
const ACHIEVED_MESSAGE_ATTRIBUTE = 'data-achieved-message'

export class FreeShippingBar extends BaseComponent {
  constructor() {
    super()
    this.updateProgressByDifference(
      this.getAttribute(DIFFERENCE_ATTRIBUTE),
      +this.getAttribute(DIFFERENCE_PERCENT_ATTRIBUTE),
    )
  }

  updateProgressByDifference(
    difference: string,
    differencePercent: number,
  ): void {
    const progressMessage = this.getAttribute(PROGRESS_MESSAGE_ATTRIBUTE) ?? ''
    const achievedMessage = this.getAttribute(ACHIEVED_MESSAGE_ATTRIBUTE) ?? ''

    if (differencePercent < 100) {
      this.setText(progressMessage.replace('[value]', difference))
      this.setProgress(differencePercent)
    } else {
      this.setText(achievedMessage)
      this.setProgress(100)
    }
  }

  setProgress = (value: number): void => {
    const dots = $el(PROGRESS_BAR_DOTS, this)

    if (dots) {
      dots.setAttribute('style', `--gsc-freeshipping-bar-percent: ${value}%`)
    }
  }

  setText = (text: string): void => {
    const messageNode = $el(MESSAGE_NODE_SELECTOR, this)
    messageNode?.replaceChildren(text)
  }
}
